const $map = document.querySelector('.contacts__map')
if ($map) {
	const mapPlacemark = $map.getAttribute('data-placemark').split('|')

	const initMap = () => {
		let myMap = new ymaps.Map($map, {
			center: JSON.parse(mapPlacemark[0]),
			zoom: window.innerWidth > 991 ? 4 : 3
		}, {
			searchControlProvider: 'yandex#search'
		})
		mapPlacemark.forEach(item => {
			const placemark = new ymaps.Placemark(JSON.parse(item),{}, {
				iconLayout: 'default#image',
				iconImageHref: WPJS.siteUrl + '/images/contacts/map.svg',
				iconImageSize: window.innerWidth > 991 ? [80, 91] : [35, 40],
				iconImageOffset: window.innerWidth > 991 ? [-40, -45] : [-17, -20]
			})
			myMap.geoObjects.add(placemark)
		})
	}
	ymaps.ready(initMap)
}
